var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dp-perf-overlay__fps"},[_c('span',{class:{
      'dp-perf-overlay__fps-value': true,
      'dp-perf-overlay__fps-value--good': _vm.currentFps > 40,
      'dp-perf-overlay__fps-value--warning': _vm.currentFps <= 40 && _vm.currentFps > 25,
      'dp-perf-overlay__fps-value--bad': _vm.currentFps < 25,
    }},[_vm._v(" "+_vm._s(_vm.currentFps)+" ")]),_c('span',{staticClass:"dp-perf-overlay__fps-label"},[_vm._v(" Frames per second ")])])}
var staticRenderFns = []

export { render, staticRenderFns }